import { useAuthStore } from '@/store/auth-store';
import { sessionScope, sessionRevision, sessionTenantId, requireCurrentSession } from '@/features/auth/session-scope';
import { getLocaleSnapshot } from '@/lib/i18n/runtime';
import { VoiceAPIError, voiceUUID, type VoiceOwner } from './voice-contract';
export interface VoiceSession extends VoiceOwner { scope: string; revision: number; language: string }
export function captureVoiceOwner(): VoiceSession {
  const state = useAuthStore.getState(); return { user: state.user?.id ?? '', tenant: sessionTenantId(state), scope: sessionScope(state), revision: sessionRevision(), language: getLocaleSnapshot().locale };
}
export const isCurrentVoiceOwner = (owner: VoiceSession) => owner.revision === sessionRevision() && owner.scope === sessionScope(useAuthStore.getState());
export function requireVoiceOwner(owner: VoiceSession, signal?: AbortSignal) {
  requireCurrentSession(owner.revision); signal?.throwIfAborted();
  if (!isCurrentVoiceOwner(owner)) throw new DOMException('Aborted', 'AbortError');
}
export function voiceAuthorization(owner: VoiceSession) {
  requireVoiceOwner(owner); const token = useAuthStore.getState().token;
  if (!token || !voiceUUID(owner.user) || !voiceUUID(owner.tenant)) throw new VoiceAPIError('unauthorized', 401);
  return token.startsWith('Bearer ') ? token : 'Bearer ' + token;
}
export const voiceKey = (channel: string, owner = captureVoiceOwner()) => ['voice', 'participants', channel, 'owner', owner.scope, owner.revision] as const;
export const ownsVoiceKey = (key: readonly unknown[], owner: VoiceSession) => key[0] === 'voice' && key[1] === 'participants' && key[3] === 'owner' && key[4] === owner.scope && key[5] === owner.revision;
